import {
    ADD_TEAM_DATA_REQUEST,
    ADD_TEAM_DATA_SUCCESS,
    ADD_TEAM_DATA_FAILURE
} from "../../../actions/admin/constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const addTeamDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TEAM_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.fetchType,
            };
        case ADD_TEAM_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.fetchType,
                error: null,
            };
        case ADD_TEAM_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.fetchType,
                data: null,
            };
        default:
            return state;
    }
};

export default addTeamDataReducer;
